import { type LoggedInUser } from './types';
import { fetchQuery, graphql } from 'react-relay';
import { type IEnvironment } from 'relay-runtime';
import { type utils_CurrentUser_Query } from './__generated__/utils_CurrentUser_Query.graphql';

export type FetchUserProfileResult = {
	identity: LoggedInUser | null;
	error: boolean;
	loginRedirectFailed: boolean;
};

type QueryUserProfileResponse =
	| {
			success: true;
			identity: LoggedInUser;
	  }
	| {
			success: false;
			error?: any;
	  };

export async function queryUserProfile(
	environment: IEnvironment,
): Promise<QueryUserProfileResponse> {
	try {
		const data = await fetchQuery<utils_CurrentUser_Query>(
			environment,
			graphql`
				query utils_CurrentUser_Query {
					me {
						user {
							... on AtlassianAccountUser {
								id
								accountId
								name
								nickname
								picture
								email
							}
						}
					}
				}
			`,
			{},
		).toPromise();

		const id = data?.me?.user?.id ?? '';
		const accountId = data?.me?.user?.accountId ?? '';
		const email = data?.me?.user?.email ?? '';
		const name = data?.me?.user?.name ?? '';
		const nickname = data?.me?.user?.nickname ?? '';
		const picture = data?.me?.user?.picture ?? '';
		if ([id, accountId, email, name, nickname, picture].some((x) => x.length === 0)) {
			return { success: false };
		}
		const normalizedEmail = email.toLowerCase();
		const isAtlassianEmployee = normalizedEmail.endsWith(ATLASSIAN_EMAIL_DOMAIN);
		return {
			success: true,
			identity: {
				id,
				accountId,
				email,
				name,
				nickname,
				picture,
				staffId: getStaffIdFromEmail(email),
				isAtlassianEmployee,
			},
		};
	} catch (e) {
		return { success: false, error: e };
	}
}

const ATLASSIAN_EMAIL_DOMAIN = '@atlassian.com';

const getStaffIdFromEmail = (email: string): string => {
	return email.split('@').at(0) ?? '';
};
